module.exports = __webpack_public_path__ + "img/swift_logo (1).e442d620.png";